export default {"src":"/_next/static/media/community-panel-icon-filled.2072ee97.svg","height":82,"width":115,"blurWidth":0,"blurHeight":0};